<template>
    <el-dialog title="查看" width="900px" :visible="infoState" :close-on-click-modal="false" @close="infoClose">
        <p>档位内容配置：（传统POS机）</p>
        <el-table :data="infoList" size="mini" border style="width: 100%" max-height="600px"
            v-loading="loading">
            <el-table-column header-align="center" align="center" label="单政策累计库存" prop="alias_name">
            </el-table-column>
            
            <el-table-column header-align="center" align="center" label="结算价格（%）" prop="profit">
            </el-table-column>
            
            <el-table-column header-align="center" align="center" label="流量卡奖励比例（%）" prop="flow_fee">
            </el-table-column>
            
            <el-table-column header-align="center" align="center" label="自由调价奖励比例（%）" prop="freedom_fee">
            </el-table-column>
            <el-table-column header-align="center" align="center" label="平台涨价奖励比例（%）" prop="platform_up_ratio">
            </el-table-column>
        </el-table>
        <p>档位内容配置：（手机POS）</p>
        <el-form class="demo-form-inline" label-width="130px" :model="mobile_from" :rules="rules" ref="mobile_from">
			<!-- count_num 已经设置过的不允许 修改  is_mpos 不是手机POS的不能改    -->
            <el-form-item label="标准结算价上浮(%)" prop="up_count_num">
                <el-input style="width:150px;margin-right:10px" clearable v-model="mobile_from.up_count_num" :disabled="mobile_from.count_num !=0 || is_mpos == 2"  placeholder="请输入上浮比例(%)"></el-input>
                <el-button type="primary" :disabled="mobile_from.count_num !=0 || is_mpos == 2" @click="handleUpCountNum">确认并刷新</el-button>
            </el-form-item>
            <div class="tableDiv" ref="tableDiv">
                <el-table :data="mobile_from.data" size="mini" border style="width: 505px"
                    v-loading="loading">
                    <el-table-column header-align="center" align="center" label="单政策累计库存" prop="index" width="250px"></el-table-column>
                    <el-table-column header-align="center" align="center" label="结算价格（%）" prop="profit" width="250px">
                    <template slot-scope="scope">
                        <div style="display: flex;justify-content: flex-start;align-items: center;">
                            <el-input size="medium" clearable v-model="scope.row.profit"
                                placeholder="请输入单政策累计库存"
                                disabled
                                >
                            </el-input>
                        </div>
                    </template>
                </el-table-column>
                </el-table>
            </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="infoClose()">返回</el-button>
            <el-button v-if="is_mpos == 1 && mobile_from.count_num ==0" type="primary" @click="addSubmit('mobile_from')">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    name:"catinfo",
    props: {
        infoState:Boolean,
        group_id:Number,
		is_mpos:Number,
    },
    data() {
        return {
            //查看
            infoList:[], //主要数据 
            loading: true, // loading 
            mobile_from :{ //手机POS数据 
					up_count_num:0,
					data:[
						{
							index:"与传统pos机库存量一致",
							profit:0,
							id:'',
							group_id:'',
						},
						{
							index:"与传统pos机库存量一致",
							profit:0,
							id:'',
							group_id:'',
						},
						{
							index:"与传统pos机库存量一致",
							profit:0,
							id:'',
							group_id:'',
						},
					]
			},
			rules: {
				up_count_num: [{
					required: true,
					message: '请输入上浮比例',
					trigger: 'blur'
				}, ],
				
			}
        }
    },
    created() {
        console.log('group_id1',this.group_id);
        this.selUserLevelByGroupId(this.group_id)
    },
    watch: {
      
    },
    methods: {
        infoClose(){ //关闭页面
            this.mobile_from = { 
					up_count_num:0,
					count_num:0,
					data:[
						{
							index:"与传统pos机库存量一致",
							profit:0,
							id:'',
							group_id:'',
						},
						{
							index:"与传统pos机库存量一致",
							profit:0,
							id:'',
							group_id:'',
						},
						{
							index:"与传统pos机库存量一致",
							profit:0,
							id:'',
							group_id:'',
						},
					]
				}
                this.$emit('setInfoState',false);
			},
        /**
         *获取数据  
         */
         selUserLevelByGroupId(group_id){
				this.$api.post("userlevel/selUserLevelByGroupId", {group_id:group_id}, res => {
					this.loading = false;
					this.infoList = res.data.list;
					this.mobile_from.up_count_num = res.data.up_ratio;
					this.mobile_from.count_num = res.data.up_ratio;
					for(let i in res.data.list){
					    this.mobile_from.data[i].profit = res.data.list[i].profit;
						this.mobile_from.data[i].id = res.data.list[i].id;
						this.mobile_from.data[i].group_id = res.data.list[i].group_id;
					}	
					// console.log('infolist',this.infoList);
					// console.log('data',this.mobile_from.data);
				})
		},
        /**
         * 计算费率上浮值
         */
        handleUpCountNum(){
				if(this.mobile_from.up_count_num >= 1 ){
					this.$message({
						type: 'error',
						message: '结算价格不能超过1',
						duration: 2000,
					});
					return false;
				}
				//使用原始数据 进行遍历赋值 
				for(let i in this.infoList){
					let new_profit = this.mobile_from.up_count_num > 0 ? parseFloat(this.infoList[i].profit) + parseFloat(this.mobile_from.up_count_num):parseFloat(this.infoList[i].profit);
					if(new_profit >=1){
						this.$message({
							type: 'error',
							message: '结算价格不能超过1',
							duration: 2000,
						})
						break;
					}
					this.mobile_from.data[i].profit = new_profit.toFixed(3);
				}	

		},
		// 提交数据 
		addSubmit(formName) {
				console.log(this.mobile_from.data);
				for (let i in this.mobile_from.data) {
					if (this.mobile_from.data[i].profit > 1) {
						this.$message({
							type: 'error',
							message: '结算价格不能超过1',
							duration: 2000,
						})
						break;
					}
				}
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post("userlevel/upUserLervelAndRate", this.mobile_from, res => {
							if (res.code == 0) {
								this.$message({
									type: 'success',
									message: res.msg,
									duration: 2000,
								})
								this.$refs[formName].resetFields();
								this.infoClose();
							}else{
								this.$message({
									type: 'error',
									message: res.msg,
									duration: 2000,
								})
							}
						})
					}
				});
			},

       
    }
}

</script>
<style scoped lang='scss'>
.tableDiv {
	overflow-x: scroll;
}
.el-form-item {
	margin-bottom: 20px !important;
}

</style>
